export default __webpack_public_path__ + "static/media/CS_194.9259e857.png";